<template>
  <div class="row">
    <div class="col-md-8" v-if="loading">
      <h4>loading...</h4>
    </div>
    <div class="col-md-8" v-if="!loading && Object.keys(pagerduty_licenses).length>0">
      <chart-card :key='pagerduty_license_data' :chart-data="pagerduty_license_data.data" :chart-options="pagerduty_license_data.options" :responsive-options="pagerduty_license_data.responsiveOptions">
        <template slot="header">
          <h4 class="card-title">Pager Duty license usage</h4>
        </template>
        <template slot="footer">
          <div class="legend">
            <i class="fa fa-circle text-info"></i> Licences Used
            <i class="fa fa-circle text-danger"></i> Licenses Bought
          </div>
        </template>
      </chart-card>
    </div>
    <div class="col-md-8" v-if="!loading && Object.keys(pagerduty_licenses_by_group).length>0">
      <chart-card :key='pagerduty_license_data_by_group' :chart-data="pagerduty_license_data_by_group.data"
                  :chart-options="pagerduty_license_data_by_group.options" :responsive-options="pagerduty_license_data_by_group.responsiveOptions" chart-type="Bar">
        <template slot="header">
          <h4 class="card-title">Pager Duty license usage by group</h4>
        </template>
      </chart-card>
    </div>

    <div class="col-md-10">
      <DxSankey
        id="sankey"
        :data-source="sankey"
        source-field="source"
        target-field="target"
        weight-field="weight"
        title="Licence usage"
      >
        <DxSize :height="800" />
        <DxTooltip
          :enabled="true"
          :customize-link-tooltip="customizeLinkTooltip"
        />
        <DxNode
          :width="10"
          :padding="15"
        />
        <DxLink color-mode="gradient"/>
      </DxSankey>
    </div>
  </div>
</template>
<script>
import LTable from 'src/components/Table.vue'
import axios from "axios";
import {chart_base, formatMoney} from "@/globalVariables";
import ChartCard from "@/components/Cards/ChartCard";
import DxSankey, {
  DxTooltip,
  DxNode,
  DxLink,
  DxSize
} from 'devextreme-vue/sankey';


export default {
  name: 'pager-duty-licenses',
  components: {
    LTable,
    ChartCard,
    DxSankey,
    DxTooltip,
    DxNode,
    DxLink,
    DxSize
  },
  data () {
    return {
      pagerduty_licenses: null,
      pagerduty_license_data: null,
      pagerduty_licenses_by_group: null,
      pagerduty_license_data_by_group: null,
      accessToken: null,
      loading: true,
      sankey: [],
    }
  },
  async created() {
    try {
      this.accessToken = await this.$auth.getAccessToken()
      this.loadData();

    } catch (e) {
      console.error(e)
    }
  },
  methods:{
    loadData() {
      axios
        .get('pagerduty/licenses?access_token=' + this.accessToken, {})
        .then(response => {
            this.pagerduty_licenses = response.data.licenses;
            this.pagerduty_licenses_by_group = response.data.licenses_by_group;
            this.loading = false;
        });
    },
  },
  watch: {
    pagerduty_licenses: function (){
        let labels = [];
        let used_licenses = [];
        let max_licenses = [];
        let vm = this;

        this.pagerduty_licenses.forEach(function (v, index) {
            labels.push(v['date'])
            used_licenses.push(v['licenses_used'])
            max_licenses.push(v['licenses_allowed'])
        });

        chart_base.options.tooltip.tooltipOffset.x = 15;
          chart_base.options.tooltip.tooltipOffset.y = 70;
          this.pagerduty_license_data = {
            'data': {
              'labels': labels,
              'series': [used_licenses, max_licenses]
            },
            'options': Object.assign({}, chart_base.options),
            'responsiveOptions': Object.assign({}, chart_base.responsiveOptions),
          }

    },
    pagerduty_licenses_by_group: function (){
      let labels = [];
      let used_licenses = [];
      let vm = this;

      for (let org in vm.pagerduty_licenses_by_group) {
        used_licenses.push(vm.pagerduty_licenses_by_group[org]['count'])
        if (org != 'count') {
          labels.push(org);
          for (let cu in vm.pagerduty_licenses_by_group[org]) {
            if (cu != 'count') {
              vm.sankey.push({source: org, target: cu, weight: vm.pagerduty_licenses_by_group[org][cu]['count']});
              for (let pack in vm.pagerduty_licenses_by_group[org][cu]) {
                if (pack != 'count') {
                  vm.sankey.push({ source: cu, target: pack, weight: vm.pagerduty_licenses_by_group[org][cu][pack]['count']});
                }
              }
            }
          }
        }
      }

      this.pagerduty_license_data_by_group = {
        'data': {
          'labels': labels,
          'series': [used_licenses]
        },
        'options': {
          'horizontalBars': true,
          'seriesBarWidth': 10,
          'seriesBarDistance': 10,
          'axisX': {
            'showGrid': true
          },
          'chartPadding': {
            'right': 0,
            'left': 170,
          },
          'tooltip':{
            'tooltipFnc': function(meta, value){
              return(value)
            },
            tooltipOffset: {
              x: 15,
              y: 70
            },
            'appendToBody':false,
            'transformTooltipTextFnc': function(value) {
              return value
            }
          },
        },
        'responsiveOptions': Object.assign({}, chart_base.responsiveOptions),
      }
    }
  }
}

</script>
<style>

</style>
